module.exports = __webpack_public_path__ + "static/media/perspective-taking.10cc079e.png";